export default __webpack_public_path__ + "static/media/notAvailable.d1184a08.png";